import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useDataContext } from "../Context/dataContext";

function Sadminlogin() {
  const navigate = useNavigate();
  const { setLogged, setInfoTkn, url } = useDataContext();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async (email, password) => {
    try {
      const response = await axios.get(
        `${url}/Auth/loginSuperAdmin/${email}/${password}`
      );
      setInfoTkn(response.data.data.access_token);
      setLogged(true);
      navigate("/Dashboard");
    } catch (error) {
      toast.error("Ocurrió un error. Verifica tus credenciales e intenta de nuevo.");
      await axios.get(
        `${url}/Auth/logoutSuperAdmin/${email}`
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await fetchData(user, password);
    } catch (error) {
      toast.error("Usuario o contraseña incorrectos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sadmin-login-container">
      <div className="sadmin-login-box">
        <h2>Super Administrador</h2>
        <form onSubmit={handleSubmit}>
          <div className="sadmin-form-group">
            <label htmlFor="user">Usuario</label>
            <input
              type="text"
              id="user"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              required
            />
          </div>
          <div className="sadmin-form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button className="sadmin-login-btn" type="submit" disabled={loading}>
            {loading ? "Cargando..." : "Iniciar Sesión"}
          </button>
        </form>
        <ToastContainer />
      </div>
    </div>
  );
}

export {Sadminlogin};